import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-y-6 py-4" }
const _hoisted_2 = ["onDrop"]
const _hoisted_3 = { class: "text-primary30 mb-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-[16px] text-textPrimary text-center" }, [
  /*#__PURE__*/_createTextVNode(" Arraste o arquivo ou "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-[#0043CE] underline" }, "clique aqui"),
  /*#__PURE__*/_createTextVNode(" para selecionar ")
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-4 text-center text-[14px] text-primary30" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Formatos aceitos: .jpeg, .jpg, .png e .pdf"),
  /*#__PURE__*/_createElementVNode("p", null, "O arquivo não pode ser maior que 50mb")
], -1)
const _hoisted_6 = {
  key: 0,
  class: "flex items-center justify-between bg-white"
}
const _hoisted_7 = { class: "flex items-center gap-x-3" }
const _hoisted_8 = { class: "text-neutralLight" }
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "text-sm font-medium text-textPrimary truncate max-w-[250px]" }
const _hoisted_11 = { class: "text-xs text-left text-neutralLight" }
const _hoisted_12 = { class: "flex items-center gap-x-2" }

import { ref } from 'vue'
import { mdiTrayArrowUp, mdiFileOutline, mdiTrayArrowDown, mdiCloseCircleOutline } from '@mdi/js'
import { useToast } from 'vue-toastification'

const MAX_FILE_SIZE = 50 * 1024 * 1024 // 50MB


export default /*#__PURE__*/_defineComponent({
  __name: 'StepFile',
  props: {
    modelValue: {}
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props;





const fileInput = ref<HTMLInputElement | null>(null)
const toast = useToast()

const triggerFileInput = () => {
  fileInput.value?.click()
}

const handleFileChange = (e: Event) => {
  const target = e.target as HTMLInputElement
  if (target.files?.length) processFile(target.files[0])
}

const handleFileDrop = (e: DragEvent) => {
  if (e.dataTransfer?.files.length) processFile(e.dataTransfer.files[0])
}

const processFile = async (file: File) => {
  if (file.size > MAX_FILE_SIZE) {
    toast.error('O arquivo excede o limite de 50MB.')
    if (fileInput.value) fileInput.value.value = ''
    return
  }

  // Materializa o conteudo do arquivo em memoria no momento da selecao.
  // Em navegadores mobile, o File original e uma referencia "lazy" (ex: arquivos
  // vindos de apps como CamScanner/Files) que pode ficar inacessivel na hora do
  // upload, fazendo o POST falhar antes de chegar ao backend. Ler o buffer aqui
  // garante que o conteudo estara disponivel no submit. NAO remover (regressao
  // conhecida: adicionado em #1430, removido por engano em #1751).
  try {
    const buffer = await file.arrayBuffer()
    const inMemoryFile = new File([buffer], file.name, {
      type: file.type,
      lastModified: file.lastModified
    })
    emit('update:modelValue', inMemoryFile)
  } catch (err) {
    console.error('[file-select] failed to buffer file:', err)
    // eslint-disable-next-line no-restricted-syntax -- falha local ao ler o arquivo, não erro de API
    toast.error('Não foi possível carregar o arquivo. Tente novamente.')
    if (fileInput.value) fileInput.value.value = ''
  }
}

const removeFile = () => {
  emit('update:modelValue', null)
  if (fileInput.value) fileInput.value.value = ''
}

const downloadFile = () => {
  if (!props.modelValue) return

  const url = URL.createObjectURL(props.modelValue)
  const link = document.createElement('a')
  link.href = url
  link.download = props.modelValue.name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

const formatSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'kb', 'mb', 'gb']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(0)) + sizes[i]
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      "data-testid": "upload-modal-arquivo-input",
      class: "relative border-2 border-dashed border-primary30 rounded-[24px] bg-primary5/30 p-10 flex flex-col items-center justify-center transition-all cursor-pointer hover:opacity-80",
      onClick: triggerFileInput,
      onDragover: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"])),
      onDrop: _withModifiers(handleFileDrop, ["prevent"])
    }, [
      _createElementVNode("input", {
        type: "file",
        ref_key: "fileInput",
        ref: fileInput,
        class: "hidden",
        accept: ".jpeg,.jpg,.png,.pdf",
        onChange: handleFileChange
      }, null, 544),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          icon: _unref(mdiTrayArrowUp),
          size: "64"
        }, null, 8, ["icon"])
      ]),
      _hoisted_4,
      _hoisted_5
    ], 40, _hoisted_2),
    (_ctx.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_v_icon, {
                icon: _unref(mdiFileOutline),
                size: "48"
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.modelValue.name), 1),
              _createElementVNode("span", _hoisted_11, _toDisplayString(formatSize(_ctx.modelValue.size)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("button", {
              "data-testid": "upload-modal-download-button",
              onClick: downloadFile,
              class: "p-2 text-primary30 hover:bg-negative/10 rounded-full transition-colors"
            }, [
              _createVNode(_component_v_icon, {
                icon: _unref(mdiTrayArrowDown),
                size: "24"
              }, null, 8, ["icon"])
            ]),
            _createElementVNode("button", {
              "data-testid": "upload-modal-remove-file-button",
              onClick: removeFile,
              class: "p-2 text-primary30 hover:bg-negative/10 rounded-full transition-colors"
            }, [
              _createVNode(_component_v_icon, {
                icon: _unref(mdiCloseCircleOutline),
                size: "24"
              }, null, 8, ["icon"])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})